"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function linearTween(timeElapsed, start, distance, duration) {
    return distance * timeElapsed / duration + start;
}
exports.default = linearTween;
